<!-- Accessibility enabled template -->
<ng-container *ngIf="enableDataTableAccessibility$ | async; else oldTemplate">
<div class="slider-container">
    <app-sr-only>
      <div [attr.id]="descriptionId">
        Range slider with two handles. Use arrow keys to select minimum value from {{ min }} to {{ max - step }}, and maximum value from {{ min + step }} to {{ max }}.
      </div>
    </app-sr-only>

    <div class="labels">
      <span>{{ minValue }}</span>
      <span>{{ maxValue }}</span>
    </div>

    <div class="range-slider">
      <input
        type="range"
        class="thumb thumb-left"
        [attr.id]="minInputId"
        [attr.aria-label]="minAccessibleLabel"
        [attr.aria-describedby]="descriptionId"
        [attr.aria-valuemin]="min"
        [attr.aria-valuemax]="max - step"
        [attr.aria-valuenow]="minValue"
        [attr.aria-valuetext]="minValue.toString()"
        aria-orientation="horizontal"
        [(ngModel)]="minValue"
        [min]="min"
        [max]="max - step"
        [step]="step"
        (input)="updateMinThumbPosition()"
      />
      <input
        type="range"
        class="thumb thumb-right"
        [attr.id]="maxInputId"
        [attr.aria-label]="maxAccessibleLabel"
        [attr.aria-describedby]="descriptionId"
        [attr.aria-valuemin]="min + step"
        [attr.aria-valuemax]="max"
        [attr.aria-valuenow]="maxValue"
        [attr.aria-valuetext]="maxValue.toString()"
        aria-orientation="horizontal"
        [(ngModel)]="maxValue"
        [min]="min + step"
        [max]="max"
        [step]="step"
        (input)="updateMaxThumbPosition()"
      />

      <div class="slider-track"></div>
      <div
        class="range"
        [style.left]="leftPosition"
        [style.right]="rightPosition"
      ></div>
    </div>
  </div>
</ng-container>

<!-- Original template (flag OFF) -->
<ng-template #oldTemplate>
<div class="slider-container">
    <app-sr-only>
      <div [attr.id]="descriptionId">
        Range slider with two handles. Use arrow keys to select minimum value from {{ min }} to {{ max - step }}, and maximum value from {{ min + step }} to {{ max }}.
      </div>
    </app-sr-only>

    <div class="labels">
      <span>{{ minValue }}</span>
      <span>{{ maxValue }}</span>
    </div>

    <div class="range-slider">
      <input
        type="range"
        class="thumb thumb-left"
        [attr.id]="minInputId"
        [attr.aria-label]="minAccessibleLabel"
        [attr.aria-describedby]="descriptionId"
        [attr.aria-valuemin]="min"
        [attr.aria-valuemax]="max - step"
        [attr.aria-valuenow]="minValue"
        [attr.aria-valuetext]="minValue.toString()"
        aria-orientation="horizontal"
        [(ngModel)]="minValue"
        [min]="min"
        [max]="max - step"
        [step]="step"
        (input)="updateMinThumbPosition()"
      />
      <input
        type="range"
        class="thumb thumb-right"
        [attr.id]="maxInputId"
        [attr.aria-label]="maxAccessibleLabel"
        [attr.aria-describedby]="descriptionId"
        [attr.aria-valuemin]="min + step"
        [attr.aria-valuemax]="max"
        [attr.aria-valuenow]="maxValue"
        [attr.aria-valuetext]="maxValue.toString()"
        aria-orientation="horizontal"
        [(ngModel)]="maxValue"
        [min]="min + step"
        [max]="max"
        [step]="step"
        (input)="updateMaxThumbPosition()"
      />

      <div class="slider-track"></div>
      <div
        class="range"
        [style.left]="leftPosition"
        [style.right]="rightPosition"
      ></div>
    </div>
  </div>
</ng-template>
